(() => {
  const improvePopupControls = () => {
    document.querySelectorAll('[class*="ecomsend__Modal__CloseButton"]').forEach((button) => {
      button.setAttribute("role", "button");
      button.setAttribute("aria-label", "Close newsletter popup");
      button.setAttribute("tabindex", "0");

      if (button.dataset.kojierPremiumEnhanced === "true") return;
      button.dataset.kojierPremiumEnhanced = "true";

      button.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        button.click();
      });
    });
  };

  const hideIntrusiveDiscountWidgets = () => {
    document.querySelectorAll('[class*="ecomsend__Popover__Widget"]').forEach((widget) => {
      widget.setAttribute("aria-hidden", "true");
    });
  };

  const prioritizeFirstHeroImage = () => {
    const heroImage = document.querySelector(".ke-feature-image");
    if (!heroImage) return;
    heroImage.setAttribute("fetchpriority", "high");
    heroImage.setAttribute("decoding", "async");
  };

  const run = () => {
    improvePopupControls();
    hideIntrusiveDiscountWidgets();
    prioritizeFirstHeroImage();
  };

  run();

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
